export default {
  accessToken: null,
  profile: null,
  username: null
}
